import { useKidStore } from '@entities/customer'
import { useActiveKidDisciplinesApi } from '@entities/customer'

export default defineNuxtRouteMiddleware(() => {
  const kidId = useKidStore().activeKidId
  if (kidId === null) return

  void useActiveKidDisciplinesApi(kidId)
})
